import React from 'react';
import { Player, ControlBar, VolumeMenuButton } from 'video-react';
import apiCall from "../apiCall";
import getUrlVars from '../../helpers/getUrlVars';
import tabInfo from '../../helpers/tabInfo';

class Video extends React.Component {
  static defaultProps = {
    desktop: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      gameMaterial: null,
      isFullscreen: false
    }
  }

  componentWillMount() {
    this.fetchMaterials();

    const getParams = getUrlVars();
    if (getParams.windowTitle && getParams.windowTitle !== 'null') {
      tabInfo.setWindowTitle(decodeURIComponent(getParams.windowTitle));
    }
    if (getParams.faviconUrl && getParams.faviconUrl !== 'null') {
      tabInfo.setFavicon(decodeURIComponent(getParams.faviconUrl));
    }
    if (getParams.backgroundUrl && getParams.backgroundUrl !== 'null') {
      this.backgroundUrl = decodeURIComponent(getParams.backgroundUrl);
    }
  }

  componentDidMount() {
    this.refs.player.subscribeToStateChange(this.handleStateChange.bind(this));
  }

  minimizeVid = (e) => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }

  handleStateChange(state) {
    const { isFullscreen } = this.state;
    if (state.isFullscreen !== isFullscreen) {
      this.setState({
        isFullscreen: state.isFullscreen
      })
    }
  }

  fetchMaterials() {
    const { videoId } = this.props.match.params;
    const getParams = getUrlVars();
    if (getParams.publicMaterialId && getParams.publicMaterialId !== 'null') {
      apiCall(`/file/generalMaterial/${getParams.publicMaterialId}`, null, 'GET')
        .then((material) => {
          this.setState({ gameMaterial: material.Material });
        });
    } else {
      apiCall(`/file/${videoId}`, null, 'GET')
        .then((material) => {
          this.setState({ gameMaterial: material});
        });
    }
  }

  render() {
    const { gameMaterial, isFullscreen } = this.state;

    return (
      <div style={this.backgroundUrl ? { backgroundImage: `url(${this.backgroundUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}} className={this.props.desktop ? `portal-vimeo portal-home darkBckg${this.backgroundUrl ? ' custom-background' : ''}` : `portal-vimeo portal-home darkBckg${this.backgroundUrl ? ' custom-background' : ''}`}>
        <div className={'container video-container-begeleider'}>
          <Player
            autoPlay={false}
            muted={false}
            onEnded={(e) => this.minimizeVid(e)}
            className={'videoframe ' + (isFullscreen ? ' fullscreen' : '')}
            ref="player"
            src={(gameMaterial ? gameMaterial.url : null)} >
            <ControlBar autoHide={isFullscreen}>
              <VolumeMenuButton vertical />
            </ControlBar>
          </Player>
        </div>
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/routes/Video.js